export default __webpack_public_path__ + "locales/vi/Webhooks.json?hash=773a50c8e87e358fa07faad2295c652f";